module.exports = __webpack_public_path__ + "static/img/mixaves_loros.cd72a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mixaves_loros.jpg
// module id = uh6F
// module chunks = 0